/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createAllotmentWithFareFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, type AllotmentWithFare, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { DownloadPassengerListCsvRequestBuilderRequestsMetadata, type DownloadPassengerListCsvRequestBuilder } from './downloadPassengerListCsv/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment/{id}
 */
export interface AllotmentItemRequestBuilder extends BaseRequestBuilder<AllotmentItemRequestBuilder> {
    /**
     * The DownloadPassengerListCsv property
     */
    get downloadPassengerListCsv(): DownloadPassengerListCsvRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<AllotmentWithFare>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<AllotmentWithFare | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const AllotmentItemRequestBuilderUriTemplate = "{+baseurl}/Allotment/{id}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AllotmentItemRequestBuilderNavigationMetadata: Record<Exclude<keyof AllotmentItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    downloadPassengerListCsv: {
        requestsMetadata: DownloadPassengerListCsvRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const AllotmentItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: AllotmentItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createAllotmentWithFareFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
